import * as React from "react";
import styled from "styled-components";
import BaseLink from "./base-link";

const Root = styled(BaseLink)(({ theme }) => ({
  textDecoration: "none",
  color: theme.colors.awesome,
}));

function Link(props) {
  const {
    id,
    className,
    children,
    url,
    external = false,
    download = false,
    style,
    wistia,
  } = props;

  return (
    <Root
      id={id}
      className={className}
      data-component-name="link"
      download={download}
      external={external}
      url={url}
      style={style}
      wistia={wistia}
    >
      {children}
    </Root>
  );
}

export default Link;
